var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_4570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.7344 0H22.2656C9.96866 0 0 9.96866 0 22.2656V72.7344C0 85.0313 9.96866 95 22.2656 95H72.7344C85.0313 95 95 85.0313 95 72.7344V22.2656C95 9.96866 85.0313 0 72.7344 0Z",
    fill: "#242938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.133 12.6179H57.095L34.2965 80.1681C34.0622 80.8623 33.6161 81.4656 33.021 81.8929C32.4258 82.3202 31.7116 82.5501 30.9789 82.5502H13.8871C13.0495 82.5503 12.2397 82.2497 11.6051 81.7031C10.9705 81.1565 10.5532 80.4001 10.4292 79.5718C10.347 79.0229 10.3966 78.4623 10.574 77.9364L31.815 15C32.0492 14.3056 32.4953 13.7022 33.0906 13.2747C33.6858 12.8472 34.4001 12.6173 35.133 12.6172V12.6179Z",
    fill: "url(#paint0_linear_65_4570)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0473 57.9258H32.2209C31.8971 57.9253 31.5807 58.0224 31.3129 58.2044C31.0451 58.3865 30.8384 58.645 30.7198 58.9463C30.601 59.2475 30.5757 59.5775 30.6471 59.8932C30.7185 60.209 30.8834 60.496 31.1202 60.7168L53.499 81.6045C54.1506 82.2122 55.0083 82.5501 55.8993 82.5501H75.6196L67.0473 57.9258Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1326 12.6182C34.3918 12.6154 33.6694 12.8495 33.0711 13.2864C32.4727 13.7233 32.0298 14.3401 31.8069 15.0466L10.6004 77.8791C10.4112 78.407 10.3518 78.9726 10.4274 79.5283C10.5029 80.0839 10.7111 80.6132 11.0344 81.0714C11.3577 81.5295 11.7865 81.9031 12.2847 82.1606C12.7829 82.418 13.3357 82.5517 13.8964 82.5504H31.4295C32.0824 82.4334 32.6925 82.1454 33.1978 81.7156C33.703 81.2859 34.0852 80.7298 34.3055 80.1042L38.5348 67.6406L53.6413 81.7303C54.2743 82.254 55.0683 82.5436 55.8898 82.5504H75.5366L66.9198 57.9265L41.8008 57.9324L57.1745 12.6182H35.1326Z",
    fill: "url(#paint1_linear_65_4570)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1839 14.9969C62.9502 14.3034 62.5048 13.7008 61.9103 13.274C61.3159 12.8473 60.6025 12.6179 59.8708 12.6182H35.3945C36.1262 12.6181 36.8395 12.8476 37.4339 13.2743C38.0283 13.7011 38.4738 14.3035 38.7077 14.9969L59.9494 77.9359C60.1267 78.4619 60.1763 79.0226 60.0942 79.5717C60.0121 80.1207 59.8005 80.6423 59.477 81.0935C59.1531 81.5444 58.7266 81.9117 58.2326 82.1652C57.7387 82.4186 57.1915 82.5509 56.6363 82.5512H81.1133C81.6684 82.5508 82.2155 82.4185 82.7094 82.1649C83.2033 81.9114 83.6298 81.544 83.9536 81.0931C84.2772 80.6421 84.4888 80.1205 84.5709 79.5715C84.653 79.0225 84.6032 78.4618 84.4257 77.9359L63.1839 14.9969Z",
    fill: "url(#paint2_linear_65_4570)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_4570",
    x1: 43.1375,
    y1: 17.8003,
    x2: 20.3297,
    y2: 85.1809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_65_4570",
    x1: 50.2621,
    y1: 49.2017,
    x2: 44.9863,
    y2: 50.9856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_65_4570",
    x1: 47.3608,
    y1: 15.8352,
    x2: 72.397,
    y2: 82.5367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_4570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureIcon);
export default __webpack_public_path__ + "static/media/azure-icon.6298e22a8ab97a980bdbd4b2ecaeef81.svg";
export { ForwardRef as ReactComponent };